











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {ResponsavelGrupoEconomico} from '@/model/resource/ResponsavelGrupoEconomico'
import {ResponsavelGrupoEconomicoCollection} from '@/model/collection/ResponsavelGrupoEconomicoCollection'
import {ListResponsavelGrupoEconomicoSchema} from '@/schema/resource/ResponsavelGrupoEconomico/ListResponsavelGrupoEconomicoSchema'
import {CsvResponsavelGrupoEconomicoSchema} from '@/schema/resource/ResponsavelGrupoEconomico/CsvResponsavelGrupoEconomicoSchema'

@Component
export default class ListResponsavelGrupoEconomicoView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListResponsavelGrupoEconomicoSchema()
  collection = new ResponsavelGrupoEconomicoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponsavelGrupoEconomico) {
    Helper.pushByName(
      'editResponsavelGrupoEconomico',
      item.idResponsavelMasterFk as number,
      item.idResponsavelPermitidoFk as number
    )
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponsavelGrupoEconomicoCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvResponsavelGrupoEconomico()
    new CsvResponsavelGrupoEconomicoSchema().downloadCsv(csv.all())
  }
}
